module.exports = __webpack_public_path__ + "img/reservation.97903d1f.png";